<ng-container *ngIf="showShell">
  <!-- Mobile FAB -->
  <button *ngIf="showFab" type="button" class="coach-fab" (click)="toggle()"
    [attr.aria-label]="open ? 'Close messages' : (unread > 0 ? 'Open messages, ' + unread + ' unread' : 'Open messages')"
    [attr.aria-expanded]="open" aria-controls="coach-messenger-panel">
    <i class="bi" [class.bi-chat-dots-fill]="!open" [class.bi-x-lg]="open" aria-hidden="true"></i>
    <span class="badge" *ngIf="!open && unread > 0" aria-hidden="true">{{ unread > 99 ? '99+' : unread }}</span>
  </button>

  <!-- Desktop collapsed strip -->
  <button *ngIf="showStrip" type="button" class="coach-strip" (click)="toggle()"
    [attr.aria-label]="unread > 0 ? 'Open coach messages, ' + unread + ' unread' : 'Open coach messages'"
    aria-expanded="false" aria-controls="coach-messenger-panel">
    <i class="bi bi-chat-dots-fill" aria-hidden="true"></i>
    <span class="strip-label">Messages</span>
    <span class="badge" *ngIf="unread > 0" aria-hidden="true">{{ unread > 99 ? '99+' : unread }}</span>
  </button>

  <!-- Panel: desktop dock or mobile popup -->
  <section class="coach-panel" id="coach-messenger-panel" *ngIf="showPanel"
    [class.mobile]="isMobile" [class.desktop]="!isMobile"
    [attr.role]="isMobile ? 'dialog' : 'complementary'" [attr.aria-modal]="isMobile ? 'true' : null"
    aria-label="Messages with your coaches">
    <header class="drawer-header">
      <ng-container *ngIf="!active; else threadHeader">
        <div>
          <h2>Messages</h2>
          <p>Your coaches</p>
        </div>
        <div class="header-actions">
          <button type="button" class="icon-btn" (click)="refresh()" aria-label="Refresh" title="Refresh">
            <i class="bi bi-arrow-clockwise" [class.spin]="refreshing" aria-hidden="true"></i>
          </button>
          <button type="button" class="icon-btn" (click)="close()" [attr.aria-label]="isMobile ? 'Close messages' : 'Collapse messages'"
            aria-expanded="true">
            <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile" aria-hidden="true"></i>
          </button>
        </div>
      </ng-container>
      <ng-template #threadHeader>
        <button type="button" class="icon-btn" (click)="backToList()" aria-label="Back to your coaches">
          <i class="bi bi-chevron-left" aria-hidden="true"></i>
        </button>
        <div class="peer">
          <span class="avatar">
            <img *ngIf="active?.coach?.picture_url" [src]="active!.coach!.picture_url" alt="" />
            <span *ngIf="!active?.coach?.picture_url" aria-hidden="true">{{ initials(active?.coach?.name) }}</span>
          </span>
          <div>
            <h2>{{ active?.coach?.name }}</h2>
            <p>{{ active?.product_line_label }}</p>
          </div>
        </div>
        <div class="header-actions">
          <button type="button" class="icon-btn" (click)="refresh()" aria-label="Refresh" title="Refresh">
            <i class="bi bi-arrow-clockwise" [class.spin]="refreshing" aria-hidden="true"></i>
          </button>
          <button type="button" class="icon-btn" (click)="close()" [attr.aria-label]="isMobile ? 'Close messages' : 'Collapse messages'"
            aria-expanded="true">
            <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile" aria-hidden="true"></i>
          </button>
        </div>
      </ng-template>
    </header>

    <div class="coach-list" *ngIf="!active">
      <button type="button" class="coach-row" *ngFor="let c of coaches; trackBy: trackCoach"
        [disabled]="!c.thread_id" (click)="openThread(c)" [attr.data-thread-id]="c.thread_id"
        [attr.aria-label]="(c.coach?.name || 'Matching') + ', ' + c.product_line_label + (c.unread_count ? ', ' + c.unread_count + ' unread' : '')">
        <span class="avatar" aria-hidden="true">
          <ng-container *ngIf="c.coach; else pendingAvatar">
            <img *ngIf="c.coach.picture_url" [src]="c.coach.picture_url" alt="" />
            <span *ngIf="!c.coach.picture_url">{{ initials(c.coach.name) }}</span>
          </ng-container>
          <ng-template #pendingAvatar><i class="bi bi-hourglass-split"></i></ng-template>
        </span>
        <span class="meta">
          <span class="name">{{ c.coach?.name || 'Matching…' }}</span>
          <span class="line">{{ c.product_line_label }}</span>
        </span>
        <span class="unread" *ngIf="c.unread_count" aria-hidden="true">{{ c.unread_count }}</span>
      </button>
    </div>

    <app-coaching-chat-thread *ngIf="active"
      [threadId]="active.thread_id"
      [messages]="thread?.messages || []"
      [loading]="loadingThread"
      [hasMore]="!!thread?.has_more"
      [loadingOlder]="loadingOlder"
      [isOutgoing]="isOutgoing"
      [sendFn]="sendFn"
      [label]="'Conversation with ' + (active.coach?.name || 'your coach')"
      [emptyText]="'Say hello to ' + (active.coach?.first_name || 'your coach') + '.'"
      (sent)="onSent($event)"
      (loadOlder)="loadOlder()">
    </app-coaching-chat-thread>
  </section>

  <div class="coach-backdrop" *ngIf="isMobile && open" (click)="close()" aria-hidden="true"></div>
</ng-container>

<div class="visually-hidden" aria-live="polite" aria-atomic="true">{{ announcement }}</div>
